import capitalize from './capitalize';
import uppercase from './uppercase';
import lowercase from './lowercase';
import placeholder from './placeholder';
import truncate from './truncate';
export { capitalize, uppercase, lowercase, placeholder, truncate };